import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

export type Params = Partial<uui.domain.client.rm.Territory['notificationConfig']['earlySettings']>

/**
 * Update the Early notification config.
 */
export const updateEarlyNotificationConfig = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/territory/updateEarlyNotificationConfig', async (payload: Params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/territory/updateEarlyNotificationConfig', {
      category: 'rpc',
      type: 'rpc/territory/updateEarlyNotificationConfig',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateEarlyNotificationConfig}`,
      { tags: ['rpc', 'territory'], info: error },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update of mobile app interaction failed`,
      error,
    })
  }
})
